import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import useTingStore from '../../stores/tingStore';
import { getCollectionCount } from '../../utils/getCollectionCount';

export default function TingSocialDetails() {
    const tingDoc = useTingStore(state => state.tingDoc);
    const setTingDoc = useTingStore(state => state.setTingDoc);

    const handleChange = (event) => {
        // Change value in setUserDoc based on what is typed
        setTingDoc({
            ...tingDoc,
            [event.target.id]: event.target.value
        });
    };

    return (
        <>
            <Box component="form" className="ting-editor__form">
                <Grid container spacing={2}>
                    <Grid item xs={6} sm={4}>
                        <TextField
                            id="likes"
                            label="Likes"
                            value={getCollectionCount(tingDoc?.likes)}
                            onChange={handleChange}
                            variant="filled"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                readOnly: true,
                            }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6} sm={4}>
                        <TextField
                            id="comments"
                            label="Comments"
                            value={getCollectionCount(tingDoc?.comments)}
                            onChange={handleChange}
                            variant="filled"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                readOnly: true,
                            }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            id="userId"
                            label="Tinger"
                            value={tingDoc?.userId ?? ''}
                            onChange={handleChange}
                            size="small"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            id="adminTingedForWho"
                            label="Admin tinged for"
                            value={tingDoc?.adminTingedForWho ?? ''}
                            onChange={handleChange}
                            size="small"
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </Box>
            {tingDoc?.userData && (
                <Box className="ting-editor__profile-card">
                    <img
                        className="ting-editor__profile-avatar"
                        src={tingDoc.userData.userImg || 'https://cdn1.iconfinder.com/data/icons/random-115/24/person-1024.png'}
                        alt={tingDoc.userData.username || 'User avatar'}
                    />
                    <Box className="ting-editor__profile-meta">
                        <Typography variant="body1" sx={{ fontWeight: 700 }}>
                            {tingDoc?.adminTingedForWho ?? tingDoc.userData.username}
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'var(--color-muted)' }}>
                            {tingDoc.userData.userRole}
                        </Typography>
                        <a className="ting-editor__profile-link" href={`/users/${tingDoc.userId}`} target="_blank" rel="noopener noreferrer">
                            View Profile
                        </a>
                    </Box>
                </Box>
            )}
        </>
    );
}
